<template>
  <Can action="view" subject="ad-manager.order">
    <dialog-line-add-new
      :order="order"
      :is-on="true"
      :is-updating="isAddingLineItem"
      :is-loading="isAddingLineItem"
      :on-cancel="onCancel"
      :on-confirm="createLineItem"
    />
  </Can>

  <Can action="view-business-contact" subject="ad-manager.order">
    <dialog-line-add-new-k-b
      :order="order"
      :is-on="true"
      :on-cancel="onCancel"
      :on-confirm="createLineItem"
    />
  </Can>
</template>

<script>
  export default {
    data() {
      return {
        isAddingLineItem: false,
      };
    },
    computed: {
      order() {
        return this.$store.getters['promotions/activeItem'] || {};
      },
      orderId() {
        return Number(this.$route.params.id);
      },
      isBC() {
        return this.$ability.can('view-business-contact', 'ad-manager.order');
      },
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'promotion-details', params: { id: this.orderId } });
      },
      createLineItem(lineItem) {
        this.isAddingLineItem = true;

        const query = {
          ...lineItem,
          isBC: this.isBC,
        };

        return this.$store.dispatch('promotions/createLineItem', query)
          .then((res) => {
            if (res.success) {
              this.$store.dispatch('promotions/getOrder', this.orderId);
              this.$router.push({ name: 'promotion-details', params: { id: this.orderId } });
            }
            return res;
          })
          .finally(() => {
            this.isAddingLineItem = false;
          });
      },
    },
  };
</script>
